<!-- eslint-disable vue/valid-v-model -->
<template>
  <v-card flat tile style="width: 100%; height: 100%; background: transparent">
    <div
      class="borderTop"
      v-for="(question, index) in localQuestions"
      :key="`question-${index}`"
    >
      <question-component
        :onDeleteQuestion="() => deleteQuestion(index)"
        :question="localQuestions[index]"
        :questions="localQuestions"
        @validation-change="
          (isValid) => handleQuestionValidation(index, isValid)
        "
      ></question-component>
    </div>
    <v-divider class="my-3"></v-divider>
    <base-btn @click="addNewQuestion" type="secondary" class="mt-3">
      <span>{{ $t('message.quiz.addQuestions') }}</span></base-btn
    >
  </v-card>
</template>

<script>
import QuestionComponent from './QuestionComponent.vue'
import { createDefaultQuestion } from '@/utils/ctaGenerator'

export default {
  name: 'Questions',
  components: {
    QuestionComponent,
  },
  props: {
    questions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      localQuestions: [],
      questionsValidation: {},
    }
  },
  created() {
    this.localQuestions = this.questions
  },
  methods: {
    addNewQuestion() {
      const newIndex = this.localQuestions.length
      this.localQuestions.push(createDefaultQuestion(newIndex))
      this.$set(this.questionsValidation, newIndex, false)
    },
    deleteQuestion(index) {
      this.cleanInvalidQuestionReferences(index)

      this.localQuestions.splice(index, 1)
      this.$delete(this.questionsValidation, index)
      this.localQuestions.forEach((question, newIndex) => {
        question.index = newIndex
        if (this.questionsValidation[newIndex + 1] !== undefined) {
          this.$set(
            this.questionsValidation,
            newIndex,
            this.questionsValidation[newIndex + 1]
          )
          this.$delete(this.questionsValidation, newIndex + 1)
        }
      })
      this.emitValidationState()
    },
    cleanInvalidQuestionReferences(deletedIndex) {
      this.localQuestions.forEach((question) => {
        question.answers.forEach((answer) => {
          if (
            answer.action === 'redirect_question' &&
            answer.nextQuestion === deletedIndex
          ) {
            answer.action = 'no_action'
            answer.nextQuestion = undefined
          } else if (
            answer.action === 'redirect_question' &&
            answer.nextQuestion > deletedIndex
          ) {
            answer.nextQuestion = answer.nextQuestion - 1
          }
        })
      })
    },
    handleQuestionValidation(index, isValid) {
      this.$set(this.questionsValidation, index, isValid)
      this.emitValidationState()
    },
    emitValidationState() {
      const isAllValid = Object.values(this.questionsValidation).every(
        (isValid) => isValid
      )
      this.$emit('validation-change', isAllValid)
    },
  },
  watch: {
    questions: {
      handler(newVal) {
        this.localQuestions = newVal
        newVal.forEach((_, index) => {
          if (this.questionsValidation[index] === undefined) {
            this.$set(this.questionsValidation, index, false)
          }
        })
      },
      immediate: true,
    },
    localQuestions: {
      handler(newVal) {
        this.$emit('update:questions', newVal)
      },
      deep: true,
    },
  },
}
</script>

<style scoped lang="scss">
.v-card > *:last-child:not(.v-btn):not(.v-chip):not(.v-avatar) {
  border-radius: 8px;
}

.borderTop {
  border-top: 1px solid var(--v-neutral-95-lightest-base) !important;
}
</style>
